<svelte:options
  customElement={{
    tag: "button-biz",
    shadow: "none"
  }}
/>

<script>
  let {
    size = 'large',
    type = 'primary',
    url = '',
    id = '',
    title = '',
    blank = false,
    single = false
  } = $props();
  const isBlank = $derived(blank === true || blank === "" || blank === "true");
</script>

<a href="{url}" class="owd-button owd-button:{size} owd-button:{type} {single ? 'single-center' : ''}" target={ isBlank ? "_blank" : ""} id="{id}">{@html title}</a>

<style lang="scss">
.single-center{
  margin-left: auto;
  margin-right: auto;
}
</style>
